import {environment} from 'src/environments/environment';

const YTY = {
  BRAND_NAME: 'YTY',
  BRAND_PORTAL_NAME: 'YTYConnect',
  BRAND_LOGO: 'YTYConnect LOGO.svg',
  BASE_ROUTE: 'yty',
  BRAND_EMAIL: 'connect@ytygroup.com.my',
  // BRAND_HOST: 'https://medisafeconnect.com/customer/#'
  BRAND_HOST: 'http://localhost:4200/#'
};

export const BRAND = YTY;
export const OTHER_BRAND = YTY;
